<template>
  <select v-model="selectedStaff" class="form-control rounded-0 g-mb-25" @change="staffChanged">
    <option value="" v-if="allowNull != undefined && allowNull == true">-- No Staff --</option>
    <option
        v-for="s in staffList"
        :value="s"
        v-bind:key="s.staffId"
    >{{ s.staffFirstName }} {{ s.staffLastName }}
    </option>
  </select>
</template>


<script>
import StaffService from "../../services/staffservice";
import {onMounted, ref, toRefs, watch} from "vue";

export default {
  name: "inputstafflist",
  components: {},
  emit: ["staffChanged"],
  props: {
    farm: String,
    staff: Number,
    defaultStaff: Number,
    allowNull: Boolean,
    additionalStaff: Array
  },
  setup: function (props, {emit}) {
    const {farm, staff, defaultStaff, allowNull, additionalStaff} = toRefs(props);

    const staffService = StaffService;
    const selectedStaff = ref();
    const staffList = ref([]);

    //watch
    const staffChanged = () => {

      selectedStaff.value = staffList.value.find(s => s.staffId == staff.value);

      if (selectedStaff.value == undefined && (allowNull != undefined && allowNull.value)) {
        selectedStaff.value = '';
      }
    };

    const farmChanged = async () => {

      await loadStaff();

      if (staff.value != undefined && staff.value > 0) {

        let foundStaff = staffList.value.find(s => s.staffId == staff.value);
        if (foundStaff == null) {

          selectedStaff.value = staffList.value[0];
        } else {

          selectedStaff.value = foundStaff;
        }
        emit("staffChanged", selectedStaff.value.staffId);
        return;
      }

      selectedStaff.value = staffList.value.find(
          s =>
              s.staffId == defaultStaff.value
      );

      if (selectedStaff.value == undefined) {
        if (allowNull == undefined || !allowNull.value) {
          selectedStaff.value = staffList.value[0];

          if (selectedStaff.value != undefined)
            emit("staffChanged", selectedStaff.value.staffId);
        } else {
          selectedStaff.value = '';
        }
      }
    };

    const defaultStaffChanged = () => {
      if (staff.value != undefined && staff.value.length > 0) return;

      selectedStaff.value = staffList.value.find(
          s =>
              s.staffId == defaultStaff.value
      );

      if (selectedStaff.value != undefined)
        emit("staffChanged", selectedStaff.value.staffId);
    };

    watch(staff, staffChanged);
    watch(defaultStaff, defaultStaffChanged);
    watch(farm, farmChanged);

    //mount
    const loadStaff = async () => {
      if (farm == undefined || farm.value == undefined)
        return;

      staffList.value = await staffService.getStaff(
          farm != undefined && farm.value != undefined ? farm.value : ""
      );;

      // if there is additional staff, add them to the list
      if (additionalStaff != undefined && additionalStaff.value != undefined) {
        additionalStaff.value.forEach(s => {
          staffList.value.push(s);
        });
      }

      if (staff.value != undefined && staff.value > 0) {

        selectedStaff.value = staffList.value.find(s => s.staffId == staff.value);
        return;
      }

      selectedStaff.value = staffList.value.find(
          s => s.staffId == defaultStaff.value
      );

      if (selectedStaff.value != undefined)
        emit("staffChanged", selectedStaff.value.staffId);
    };

    onMounted(loadStaff);

    return {
      selectedStaff,
      staffList
    };
  },
  methods: {
    staffChanged() {

      this.$emit("staffChanged", this.selectedStaff.staffId);
    }
  }
};
</script>